module.exports = __webpack_public_path__ + "img/7.15265c69.jpg";